import React, {useCallback, useEffect, useState} from 'react';
import styled from 'styled-components/macro';
import {useWeb3React} from "@web3-react/core";
import { useParams } from "react-router-dom";
import { parseUnits } from '@ethersproject/units'

import LandRegistration from '../artifacts/src/contracts/LandRegistration.sol/LandRegistration';
import ManagementCompany from '../artifacts/src/contracts/ManagementCompany.sol/ManagementCompany'
import LoanOriginator from '../artifacts/src/contracts/LoanOriginator.sol/LoanOriginator'
import LoanPool from '../artifacts/src/contracts/LoanPool.sol/LoanPool'
import ERC20Token from '../artifacts/src/contracts/test/ERC20Token.sol/ERC20Token'

import Spinner from "./Spinner";

import useSortableData from "./UseSortableData";
import DepositModal from './DepositModal';
import RedeemModal from './RedeemModal';
import CurrencyModal from "./CurrencyModal";

var BigNumber = require("big-number");

const DashboardPage = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    font-family: Lato;
    font-style: normal;
    min-height: 100vh;
`

const SubTitle = styled.div`
    position: absolute;
    width: 296px;
    height: 25px;
    left: 10%;
    top: 116px;
    padding: 0px;

    font-weight: bold;
    font-size: 14px;
    line-height: 180%;
    color: #000000;
    
    opacity: 0.4;
`

const TitleRow = styled.div`
    height: 40px;
    display: flex;
    flex-direction: row;
    margin-top: 50px;
    width: 100%;
` 
const Title = styled.div`
    height: 40px;
    font-weight: bold;
    font-size: 30px;
    line-height: 100%;
    /* identical to box height, or 54px */

    text-transform: capitalize;

    color: #000000;
`
const TotalLabel = styled.div`
     margin-top: 45px;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 100%;
`
const FlexContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    justify-content: center;

    width: 80%;
    margin-left: 10%;
    margin-top: 40px;
`

const LowerTableContainer = styled.div`
    width: 100%;
    min-height: 300px;
`
const ProposalBox = styled.div`
    display: flex;
    flex-direction: column;
    width: 17%;
    align-items: flex-start;
    min-width: 240px;
    height: 150px;
    margin-left: 0px;
    margin-top: 0px;
    margin-right: 30px;
    margin-bottom: 30px;
    align-items: center;

    background: #FFFFFF;
    /* shadow 1 */
    
    box-shadow: 4px 6px 20px rgba(176, 176, 176, 0.15);
    border-radius: 6px;
`

const ProposalBoxLabel = styled.div`
    width: 100%;
    height: 18px;
    margin-top: 30px;

    font-weight: normal;
    line-height: 100%;
    /* identical to box height, or 18px */
    font-style: normal;
    font-size: 18px;

    /* identical to box height */
    text-align: center;
    letter-spacing: 0.4px;

    color: #000000;

    opacity: 0.4;
`

const ProposalNumberLabel = styled.div`
    width: 100%;
    height: 18px;
    margin-top: 20px;


    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    line-height: 47px;

    /* identical to box height */
    text-align: center;
    letter-spacing: 1px;
    color: #F0C235;
`

const StyledTable = styled.table`
  border: none;
  border-collapse: separate;
  border-spacing: 0px 20px;
  width: 100%;
  min-width: 800px;
  font-weight: bold;

  thead {
    width: 100%;
    font-weight: bold;
    font-size: 20px;
    line-height: 180%;
    text-decoration: underline;
  }
    
  td {
    border: none;
    text-align: left;
    padding: 0px 10px 0px 10px;
  }

  th {
    border: none;
    text-align: left;
    padding: 0px;
  }

  tbody tr {
    width: 100%;
    height: 66px;
        
    background: #FFFFFF;
    box-shadow: 4px 6px 20px rgba(176, 176, 176, 0.15);
 
    :hover {
      background-color: #f5f5f5;
    }
  }
`;

const ActionBtnContainer = styled.div`
    display: flex;
    flex-direction: row;
    margin-left: auto; 
`

const HeaderColumn = styled.button`
    font-weight: bold;
    font-size: 16px;
    border: none;
    background: transparent;
    text-decoration: underline;
    
    cursor: pointer;
`

const ContentContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-top: 34px;
    flex-wrap: wrap;
`

const LogoIcon = styled.div`
    margin-left: 10px;
    width: 35px;
`

const MarketInfoPage = () => {
    const web3Context = useWeb3React();
    const [loading, setLoading] = useState(true);
    const [landRegistrationSC, setLandRegistrationSC] = useState({
        address: process.env.REACT_APP_LANDREGISTRATION_ADDRESS,
        abi: LandRegistration.abi
    });

    const [ManagementCompanySC] = useState({
        address: process.env.REACT_APP_MCADMIN_ADDRESS,
        abi: ManagementCompany.abi
    });
    const [LoanOriginatorSC, setLoanOriginatorSC] = useState({
        address: process.env.REACT_APP_LOANORIGINATOR,
        abi: LoanOriginator.abi
    });


    const [loanPoolName, setLoanPoolName] = useState("");
    const [totalDeposit, setTotalDeposit] = useState(0);
    const [minRate, setMinRate] = useState("");
    const [maxRate, setMaxRate] = useState("");
    const [rateToBorrow, setRateToBorrow] = useState(0);
    const [poolReserve, setPoolReserve] = useState(0);
    const [myAssetBalance, setMyAssetBalance] = useState(0);
    const [myAssetAllowance, setMyAssetAllowance] = useState(0);
    const [myTokenBalance, setMyTokenBalance] = useState(0);
    const [currentUltilizationRate, setCurrentUltilizationRate] = useState(0);
    const [loanPoolCurrency, setLoanPoolCurrency] = useState("0x0000000000000000000000000000000000000000");
    const [currencyBase, setCurrencyBase] = useState(10 ** 18);
    const [currencyName, setCurrencyName] = useState("N/A");
    const [currencyLogo, setCurrencyLogo] = useState("");
    const [loanPoolStatus, setLoanPoolStatus] = useState("1");
    const [activeLoanEntities, setActiveLoanEntities] = useState([]);

    const currencies = CurrencyModal();

    const { loanPoolId } = useParams();

    const { items, requestSort, sortConfig } = useSortableData(activeLoanEntities);

    const loadLoanPoolInfo = useCallback(async() => {
        // one developer information returned as an array
        let loanPoolInfoArray = [];
        // land Id array stored in the developer
        let loanPoolAddress;
        let LoanPoolContract;
        let myTokenAmount;

        if(loanPoolId !== undefined && loanPoolId !== null && loanPoolId !== 0) {
            const ethLibrary = web3Context.library.eth;
            const loanOriginatorContract = new ethLibrary.Contract(
                LoanOriginatorSC.abi,
                LoanOriginatorSC.address
            );
    
            loanPoolAddress = await loanOriginatorContract.methods
                .getLoanPoolByID(loanPoolId)
                .call();

            LoanPoolContract = new ethLibrary.Contract(
                LoanPool.abi,
                loanPoolAddress
            );

            loanPoolInfoArray = await LoanPoolContract
                .methods
                .getLoanPoolInfo()
                .call();

            myTokenAmount = await LoanPoolContract
                .methods
                .balanceOf(web3Context.account)
                .call();

            setMyTokenBalance(myTokenAmount);
            setLoanPoolCurrency(loanPoolInfoArray[7]);
            setLoanPoolName(loanPoolInfoArray[0]);
            setMinRate(loanPoolInfoArray[5]);
            setMaxRate(loanPoolInfoArray[4]);
            setRateToBorrow(loanPoolInfoArray[3]);
            setPoolReserve(loanPoolInfoArray[2]);
            setTotalDeposit(parseInt(loanPoolInfoArray[1]) + parseInt(loanPoolInfoArray[2]));
            setCurrentUltilizationRate(loanPoolInfoArray[6]);
            setLoanPoolStatus(loanPoolInfoArray[8].toString());

            const currency = currencies.find(c => c.address.toLowerCase() == loanPoolInfoArray[7].toString().toLowerCase());
            setCurrencyBase(currency === undefined ? 10 ** 18 : 10 ** currency.decimal);
            setCurrencyName(currency === undefined ? "N/A" : currency.name);
            setCurrencyLogo(currency === undefined ? "" : currency.img);

            // load balance info and allowance info
            const stableTokenContract = new ethLibrary.Contract(
                ERC20Token.abi,
                currency.address
            );

            const myAssetAmount = await stableTokenContract.methods
                .balanceOf(web3Context.account)
                .call();

            setMyAssetBalance(myAssetAmount);

            const myAssetAllowance = await stableTokenContract.methods
                .allowance(web3Context.account, loanPoolAddress)
                .call();

            setMyAssetAllowance(myAssetAllowance);

            let loanEntityInfoArray = [];
            let newLoanEntityObject = {};
            let loadedDetailsArray = [];

            const activeLoanEntityIds = await LoanPoolContract.methods
                .getActiveLoanEntityIDs()
                .call();
            for(var i = 1; i < activeLoanEntityIds.length; i++) {
                loanEntityInfoArray = await LoanPoolContract.methods
                    .getLoanEntityViewByLoanEntityID(activeLoanEntityIds[i])
                    .call();
                newLoanEntityObject = {
                    loanID: loanEntityInfoArray[1],
                    developerName:loanEntityInfoArray[2],
                    principal: loanEntityInfoArray[6],
                    interestRateAPY: loanEntityInfoArray[4],
                    landName: loanEntityInfoArray[3],
                    projectType: loanEntityInfoArray[7]
                };
    
                loadedDetailsArray.push(newLoanEntityObject);
            }
            setActiveLoanEntities(loadedDetailsArray);
        }
    }, [landRegistrationSC, web3Context, LoanOriginatorSC]);

    const deposit = useCallback(async (amount) => {
        const ethLibrary = web3Context.library.eth;
        if(web3Context.account !== undefined) {
            const loanOriginatorContract = new ethLibrary.Contract(
                LoanOriginatorSC.abi,
                LoanOriginatorSC.address
            );

            const reloadedLoanPoolAddress = await loanOriginatorContract.methods
                .getLoanPoolByID(loanPoolId)
                .call();

            const LoanPoolContract = new ethLibrary.Contract(
                LoanPool.abi,
                reloadedLoanPoolAddress
            );

            const loanPoolInfoArray = await LoanPoolContract
                .methods
                .getLoanPoolInfo()
                .call();

            console.log(loanPoolInfoArray[1] + loanPoolInfoArray[2]);
            const reloadedLoanPoolCurrency = loanPoolInfoArray[7];

            const currency = currencies.find(c => c.address.toLowerCase() === reloadedLoanPoolCurrency.toString().toLowerCase());
            const decimal = currency === undefined ? 18 : currency.decimal;
            let exactAmount;


            // work around
            if(amount >= 0) {
                exactAmount =  parseUnits(amount, decimal);
            } else {
                exactAmount = 0;
            }


            await loanOriginatorContract.methods
                .deposit(exactAmount, Number(loanPoolId))
                .send({from: web3Context.account})
                .once('receipt', async() => {
                    window.location.reload();
                });
        }
    }, [web3Context, LoanOriginatorSC, loanPoolCurrency]);

    const approveToken = useCallback(async () => {
        const ethLibrary = web3Context.library.eth;
        if(web3Context.account !== undefined) {
            const loanOriginatorContract = new ethLibrary.Contract(
                LoanOriginatorSC.abi,
                LoanOriginatorSC.address
            );

            const reloadedLoanPoolAddress = await loanOriginatorContract.methods
                .getLoanPoolByID(loanPoolId)
                .call();

            const LoanPoolContract = new ethLibrary.Contract(
                LoanPool.abi,
                reloadedLoanPoolAddress
            );

            const loanPoolInfoArray = await LoanPoolContract
                .methods
                .getLoanPoolInfo()
                .call();

            const reloadedLoanPoolCurrency = loanPoolInfoArray[7];

            const stableTokenContract = new ethLibrary.Contract(
                ERC20Token.abi,
                reloadedLoanPoolCurrency
            );

            const currency = currencies.find(c => c.address.toLowerCase() === reloadedLoanPoolCurrency.toString().toLowerCase());
            const CurrencyBase = currency === undefined ? 10 ** 18 : 10 ** currency.decimal;
            let exactMaxNumber;
            // tmp fix for approval with different decimal
            if(CurrencyBase === 10 ** 18) {
                // eslint-disable-next-line no-undef
                exactMaxNumber = "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff";
            } else {
                exactMaxNumber = 1999999999 * CurrencyBase;
            }


            await stableTokenContract.methods
                .approve(reloadedLoanPoolAddress, exactMaxNumber)
                .send({from: web3Context.account})
                .once('receipt', async() => {
                    setMyAssetAllowance(1999999999 * CurrencyBase);
                });
        }

    }, [ManagementCompanySC, web3Context]);

    const redeem = useCallback(async (amount) => {
        // one developer information returned as an array
        // land Id array stored in the developer

        const ethLibrary = web3Context.library.eth;
        if(web3Context.account !== undefined) {
            const loanOriginatorContract = new ethLibrary.Contract(
                LoanOriginatorSC.abi,
                LoanOriginatorSC.address
            );

            const reloadedLoanPoolAddress = await loanOriginatorContract.methods
                .getLoanPoolByID(loanPoolId)
                .call();

            const LoanPoolContract = new ethLibrary.Contract(
                LoanPool.abi,
                reloadedLoanPoolAddress
            );

            const loanPoolInfoArray = await LoanPoolContract
                .methods
                .getLoanPoolInfo()
                .call();

            const reloadedLoanPoolCurrency = loanPoolInfoArray[7];

            const currency = currencies.find(c => c.address.toLowerCase() === reloadedLoanPoolCurrency.toString().toLowerCase());
            const decimal = currency === undefined ? 18 : currency.decimal;

            let exactAmount;


            // work around
            if(amount >= 0) {
                exactAmount =  parseUnits(amount, decimal);
            } else {
                exactAmount = 0;
            }


            await loanOriginatorContract.methods
                .withdraw(exactAmount, loanPoolId)
                .send({from: web3Context.account})
                .once('receipt', async() => {
                    window.location.reload();
                });
        }

    }, [ManagementCompanySC, web3Context, LoanOriginatorSC]);


    const loadSCAddress = useCallback(async() => {
        const ethLibrary = web3Context.library.eth;
        const MCAdminContract = new ethLibrary.Contract(
            ManagementCompany.abi,
            process.env.REACT_APP_MCADMIN_ADDRESS
        );

        const LRSC = await MCAdminContract.methods.LRSCAddress().call();

        setLandRegistrationSC({
            address: LRSC,
            abi: LandRegistration.abi
        });

        const LOSC = await MCAdminContract.methods.LOSCAddress().call();

        setLoanOriginatorSC({
            address: LOSC,
            abi: LoanOriginator.abi
        });

    }, [web3Context]);

    useEffect(() => {
        if (web3Context.active) {
            loadLoanPoolInfo();
            setLoading(false);
        }
    }, [web3Context, loadLoanPoolInfo, landRegistrationSC]);

    useEffect(() => {
        if(web3Context.active) {
            loadSCAddress();
        }
    }, [web3Context])

    return (
        loading ? (<Spinner />) : (
        <DashboardPage>
            <SubTitle>Market > {loanPoolName}</SubTitle>
            <FlexContainer>
            <TitleRow>
                <Title>
                    {loanPoolName}-{currencyName}
                </Title>
                <LogoIcon>
                    <img src={currencyLogo}/>
                </LogoIcon>

                <ActionBtnContainer>
                <DepositModal action={deposit} approve={approveToken} loanPoolName={loanPoolName} rateToBorrow={rateToBorrow} loanPoolCurrencyName={currencyName} loanPoolCurrencyBase={currencyBase} loanPoolStatus={loanPoolStatus} myAssetBalance={myAssetBalance} myAssetAllowance={myAssetAllowance}/>
                <RedeemModal action={redeem} loanPoolName={loanPoolName} rateToBorrow={rateToBorrow} loanPoolCurrencyName={currencyName} loanPoolCurrencyBase={currencyBase} myTokenBalance={myTokenBalance}/>
                </ActionBtnContainer>
            </TitleRow>

                <TotalLabel>Total Deposit: ${totalDeposit / currencyBase} {currencyName}</TotalLabel>
                <ContentContainer>
                <ProposalBox>
                    <ProposalBoxLabel>Maximum Yield</ProposalBoxLabel>
                    <ProposalNumberLabel>{maxRate/1000}%</ProposalNumberLabel>
                </ProposalBox>
                <ProposalBox>
                    <ProposalBoxLabel>Minimum Yield</ProposalBoxLabel>
                    <ProposalNumberLabel>{minRate/1000}%</ProposalNumberLabel>
                </ProposalBox>
                <ProposalBox>
                    <ProposalBoxLabel>Current Yield</ProposalBoxLabel>
                    <ProposalNumberLabel>{rateToBorrow/1000}%</ProposalNumberLabel>
                </ProposalBox>
                <ProposalBox>
                    <ProposalBoxLabel>Available liquidity</ProposalBoxLabel>
                    <ProposalNumberLabel>${(poolReserve/currencyBase).toFixed(2)}</ProposalNumberLabel>
                </ProposalBox>
                <ProposalBox>
                    <ProposalBoxLabel>Utilization Rate</ProposalBoxLabel>
                    <ProposalNumberLabel>{currentUltilizationRate/1000}%</ProposalNumberLabel>
                </ProposalBox>
                </ContentContainer>
            </FlexContainer>
            <FlexContainer>
                <Title>Current Loans</Title>
                <LowerTableContainer>
                    <StyledTable>
                        <thead>
                        <tr>
                            <th>
                                <HeaderColumn
                                    onClick={() => requestSort('loanEntityId')}>Loan ID
                                    <span>{sortConfig !== null && sortConfig.key === 'loanEntityId' ? sortConfig.direction === 'ascending' ? '▼' : '▲' : ''}</span>
                                </HeaderColumn>
                            </th>
                            <th>
                                <HeaderColumn
                                    onClick={() => requestSort('borrower')}>Borrower
                                    <span>{sortConfig !== null && sortConfig.key === 'borrower' ? sortConfig.direction === 'ascending' ? '▼' : '▲' : ''}</span>
                                </HeaderColumn>
                            </th>
                            <th>
                                <HeaderColumn
                                    onClick={() => requestSort('borrowedamount')}>Borrowed Amount
                                    <span>{sortConfig !== null && sortConfig.key === 'borrowedamount' ? sortConfig.direction === 'ascending' ? '▼' : '▲' : ''}</span>
                                </HeaderColumn>
                            </th>
                            <th>
                                <HeaderColumn
                                    onClick={() => requestSort('loaninterestrate')}>Loan Interest Rate
                                    <span>{sortConfig !== null && sortConfig.key === 'loaninterestrate' ? sortConfig.direction === 'ascending' ? '▼' : '▲' : ''}</span>
                                </HeaderColumn>
                            </th>
                            <th>
                                <HeaderColumn
                                    onClick={() => requestSort('dailyinterest')}>Daily Interest
                                    <span>{sortConfig !== null && sortConfig.key === 'dailyinterest' ? sortConfig.direction === 'ascending' ? '▼' : '▲' : ''}</span>
                                </HeaderColumn>
                            </th>
                            <th>
                                <HeaderColumn
                                    onClick={() => requestSort('collateral')}>Collateral
                                    <span>{sortConfig !== null && sortConfig.key === 'collateral' ? sortConfig.direction === 'ascending' ? '▼' : '▲' : ''}</span>
                                </HeaderColumn>
                            </th>
                            <th>
                                <HeaderColumn
                                    onClick={() => requestSort('projecttype')}>Project Type
                                    <span>{sortConfig !== null && sortConfig.key === 'projecttype' ? sortConfig.direction === 'ascending' ? '▼' : '▲' : ''}</span>
                                </HeaderColumn>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {items === undefined ? (<Spinner/>) : items.map((loanEntity, index) => {
                            return (
                                <tr key={index}>
                                    <td>{loanEntity.loanID}</td>
                                    <td>{loanEntity.developerName}</td>
                                    <td>${loanEntity.principal/currencyBase}</td>
                                    <td>{loanEntity.interestRateAPY/1000}%</td>
                                    <td>{loanEntity.interestRateAPY*loanEntity.principal/100000/currencyBase/365}</td>
                                    <td>{loanEntity.landName.length <= 20 ? loanEntity.landName : loanEntity.landName.substring(0,20) + "..."}</td>
                                    <td>{loanEntity.projectType}</td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </StyledTable>
                </LowerTableContainer>
            </FlexContainer>
        </DashboardPage>
        )
    );
}

export default MarketInfoPage;
